import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './app/app';
import { RouterProvider } from './app/store/GlobalAppData/ReactContextRouter';
import { store } from './app/store/store';
import './styles.scss';

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <RouterProvider>
        <BrowserRouter>
          <div data-iframe-height role="main" id="app-wrapper" style={{ marginBottom: '.5rem' }}>
            <App />
          </div>
        </BrowserRouter>
      </RouterProvider>
    </Provider>
  </StrictMode>,
  document.getElementById('root')
);
